import Routing from "fos-router";import routes from "/var/www/var/cache/fosRoutes.json";Routing.setRoutingData(routes);